import { ConfigurationService, ConfiguratorService } from '@/api-sdk';
import axios from 'axios';

/**
 * Get the API host URL based on the current window location.
 * @param host - The host name, defaults to the current window location host.
 * @returns The API host URL.
 */
export const getApiHost = (host: string = window.location.host) => {
  const currentHost = host.replace(/^www./, '');
  return `https://components.${currentHost}`;
};

/**
 * Set the base URL for the OpenAPI configuration.
 * @param baseUrl - The base URL to set.
 */
export const setBaseUrl = (baseUrl: string) => {
  axios.defaults.baseURL =
    baseUrl || import.meta.env.VITE_API_BASE_URL || getApiHost();
  axios.defaults.withCredentials = true;
};

/**
 * Get the current base URL from the OpenAPI configuration.
 * @returns The current base URL.
 */
export const getBaseUrl = () => {
  return axios.defaults.baseURL;
};

export { ConfigurationService, ConfiguratorService };
